// extracted by css-extract-rspack-plugin
export default {"cls1":"ShareModal-cls1_iOc","cls2":"ShareModal-cls2_ON2 ShareModal-cls1_iOc"};